module.exports = __webpack_public_path__ + "img/img7.e39abe03.jpg";